import React from "react";
import VideoCard from "@/components/VideoCard";

// Free public Pexels stock videos used as ambient placeholders.
// Real production usage: replace with actual customer UGC clips.
const VIDEOS = [
  {
    label: "Video show · Real footage",
    title: "\"How they actually feel & look.\"",
    author: "DubaiPillows · Ultra-luxe footage",
    duration: "0:18",
    poster: "/assets/color_pink.png",
    src: "/assets/ugc_video_1.mp4",
    sticker: "🎬 Video show",
    stickerCls: "sticker-lime",
  },
  {
    label: "UGC-testimonial-lifestyle",
    title: "\"Found the pillows they use at the Hiltons 🥵\"",
    author: "Verified buyer · couch nap edition",
    duration: "0:22",
    poster: "/assets/color_white.png",
    src: "/assets/ugc_video_2.mp4",
    sticker: "🛋️ Sofa drop",
    stickerCls: "sticker-lavender",
  },
  {
    label: "UGC-unboxing-reaction",
    title: "\"Hot pink, pinch-tuck, ridiculously soft.\"",
    author: "Verified buyer · bedroom reveal",
    duration: "0:35",
    poster: "/assets/color_pink.png",
    src: "/assets/ugc_video_3.mp4",
    sticker: "📦 Unboxing",
    stickerCls: "sticker-pink",
  },
  {
    label: "UGC-softness-test",
    title: "\"The softness is unreal — like sleeping on a cloud.\"",
    author: "Verified buyer · softness test",
    duration: "0:18",
    poster: "/assets/ugc_video_4_poster.jpg",
    src: "/assets/ugc_video_4.mp4",
    sticker: "☁️ Softness",
    stickerCls: "sticker-lavender",
  },
  {
    label: "UGC-premium-cotton",
    title: "\"Premium cotton shell — feels 7-star instantly.\"",
    author: "Verified buyer · fabric close-up",
    duration: "0:17",
    poster: "/assets/ugc_video_5_poster.jpg",
    src: "/assets/ugc_video_5.mp4",
    sticker: "🧵 Premium cotton",
    stickerCls: "sticker-lime",
  },
  {
    label: "UGC-goose-fibers",
    title: "\"Real goose down fibers — you can see the difference.\"",
    author: "Verified buyer · inside the pillow",
    duration: "0:18",
    poster: "/assets/ugc_video_6_poster.jpg",
    src: "/assets/ugc_video_6.mp4",
    sticker: "🪶 Goose down",
    stickerCls: "sticker-pink",
  },
];

export default function VideoTestimonialsGrid() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="aurora-wrap py-20 md:py-28">
      <div className="container-x">
        <div className="text-center max-w-3xl mx-auto">
          <span className="section-pill">🎥 Real customers · real sleep</span>
          <h2 className="mt-5 text-[34px] sm:text-[44px] md:text-[56px] leading-[1.05] font-black tracking-[-0.02em] text-[#0e0e10]">
            Don&apos;t take our word.
            <br />
            <span className="text-[#8a8a8a]">Take theirs.</span>
          </h2>
          <p className="mt-4 text-[#5a5a60] text-[15px] md:text-[16px] max-w-xl mx-auto">
            From unboxing to night 30 — watch real customers walk through their
            sleep transformation. No scripts. No filters. Just results.
          </p>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7 max-w-6xl mx-auto">
          {VIDEOS.map((v) => (
            <VideoCard key={v.title} {...v} />
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => scrollTo("shop")}
            className="pill-btn px-8 py-4 text-[15px]"
            data-testid="video-grid-cta"
          >
            Start your story — from $147 →
          </button>
          <p className="mt-3 text-[12px] text-[#8a8a8a]">
            12,000+ stories like these. 4.9 average rating. Your turn.
          </p>
        </div>
      </div>
    </section>
  );
}
